<template>
  <div>
    <div class="card" :class="$style.container">
      <div class="text-dark font-size-24 mb-4">
        <strong> {{ $t('authForm.createAccount') }} </strong>
      </div>
      <a-form class="mb-4" :form="form" @submit="handleSubmit">
        <a-form-item :label="$t('authForm.firstName')">
          <a-input
            size="large"
            :placeholder="$t('authForm.firstName')"
            v-decorator="['firstname', {rules: [{ required: true, message: $t('authForm.requiredFirstName') }]}]"
          />
        </a-form-item>
        <a-form-item :label="$t('authForm.lastName')">
          <a-input
            size="large"
            :placeholder="$t('authForm.lastName')"
            v-decorator="['lastname', {rules: [{ required: true, message: $t('authForm.requiredLastName') }]}]"
          />
        </a-form-item>
        <a-form-item label="Email">
          <a-input
            type="email"
            size="large"
            :placeholder="$t('authForm.emailAddress')"
            v-decorator="['email', {rules: [{ required: true, message: $t('authForm.requiredEmail') }]}]"
          />
        </a-form-item>
        <!-- <a-form-item :label="$t('authForm.phoneNumber')">
          <a-input
            v-decorator="[
              'phone',
              {
                rules: [{
                  required: true,
                  message: $t('authForm.requiredPhoneNumber'),
                  pattern: new RegExp(/[0-9\+]+/g, '')
                }],
              },
            ]"
            :placeholder="$t('authForm.phoneNumber')"
          />
        </a-form-item> -->
        <a-form-item :label="$t('authForm.password')">
          <a-input
            size="large"
            type="password"
            :placeholder="$t('authForm.password')"
            v-decorator="['password', {rules: [{ required: true, min: 8 }]}]"
          />
        </a-form-item>
        <a-form-item :label="$t('authForm.confirmPassword')">
          <a-input
            size="large"
            type="password"
            :placeholder="$t('authForm.confirmPassword')"
            v-decorator="['confirmpassword', {rules: [{ required: true, min: 8 }]}]"
          />
        </a-form-item>
        <a-button
          type="primary"
          size="large"
          class="text-center w-100"
          :loading="loading"
          htmlType="submit"
        >
          <strong> {{ $t('authForm.register') }} </strong>
        </a-button>
      </a-form>
      <div>
        <span class="mr-1"> {{ $t('authForm.toc') }} </span>
        <a href="javascript: void(0);" class="kit__utils__link">Terms of Service</a> {{ $t('authForm.and') }}
        <a href="javascript: void(0);" class="kit__utils__link">Privacy Policy</a>
      </div>
      <div class="text-center pt-2 mb-auto">
        <span class="mr-2"> {{ $t('authForm.alreadyHaveAccount') }} </span>
        <router-link to="/auth/login" class="kit__utils__link font-size-16"> {{ $t('authForm.signIn') }} </router-link>
      </div>
      <div>
        <a-modal v-model="modalConfirmation" title="Register Success" :closable="false" @cancel="cancelModal" @ok="cancelModal" :centered="true">
          <div class="row">
            <div class="col-12 d-flex justify-content-center text-center">
              <a-icon type="check-circle" style="color: green; font-size: 100px" />
            </div>
            <div class="col-12 d-flex justify-content-center text-center mt-4">
              <h6> {{ $t('authForm.tankYou') }} </h6>
            </div>
            <div class="col-12 d-flex justify-content-center text-center">
              <p class="text-muted"> {{ $t('authForm.registerSuccess', { email: form.getFieldValue('email') }) }}   </p>
            </div>
          </div>
        </a-modal>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CuiRegister',
  computed: {
    loading() {
      return this.$store.state.user.loading
    },
  },
  data: function () {
    return {
      form: this.$form.createForm(this),
      modalConfirmation: false,
    }
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (this.form.getFieldValue('password') !== this.form.getFieldValue('confirmpassword')) {
          return this.$notification.error({
            message: this.$t('authForm.passwrdNotmatch'),
          })
        }

        if (!err) {
          this.$store.dispatch('user/REGISTER', { payload: values })
            .then(data => {
              this.modalConfirmation = true
              this.$notification.success({
                message: this.$t('authForm.registerSuccess', { email: this.form.getFieldValue('email') }),
              })
              // this.$router.push({ name: 'otp' })
            })
            .catch(err => {
              this.$notification.error({
                message: this.$t('authForm.registerFailed'),
                description: err.response?.data?.message || err.message,
              })
            })
        }
      })
    },
    cancelModal () {
      this.$router.push('/auth/login')
      this.form.resetFields()
    },
  },
}
</script>
<style lang="scss" module>
@import "@/components/cleanui/system/Auth/style.module.scss";
</style>
